module.exports = __webpack_public_path__ + "static/media/Tia.c477b706.jpg";